import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/routes";
import { createPinia } from "pinia";

import "./assets/js/registerServiceWorker"; // ثبت Service Worker
import "./assets/js/material-dashboard.min.js";
import "bootstrap/dist/js/bootstrap.bundle";
import "bootstrap-icons/font/bootstrap-icons.min.css";
import "./assets/css/styles.css";
import "./assets/css/material-dashboard.css";
import "./assets/js/useSidebar.js";


const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount("#app");
